import fromAnyToString from 'utils/converters/fromAnyToString';

const fromAnyToNoBlankSpace = (value) => fromAnyToString(value).replace(/\s/g, '');

// noinspection JSUnusedGlobalSymbols
export default fromAnyToNoBlankSpace;
